module.exports = __webpack_public_path__ + "img/9788957982716.762a20fb.jpg";